import React, {useContext} from "react";
import { AppContext } from "../../AppContext";

import DateUtil from "../../common/dateUtil";
import StatusComp from "../../common/StatusComp";
import CommentComp from "../common/CommentComp";

const GiftDetail = (props)=>{
    const [appContext, setAppContext] = useContext(AppContext);
    const isJwCole = appContext.clientId === "jwcole"?true:false;
  
    let statusClass = "";
    if (props.data.status === "Approved") {
      statusClass = "status-green";
    } else if (props.data.status === "Pending") {
      statusClass = "status-purple";
    } else if (props.data.status === "Rejected") {
      statusClass = "status-orange";
    }

    return (

        <div className="panel-body">
        <div className="panel-columns">

            <div className="panel-column">
            
                {props.data.status && 
                <div className="panel-item">
                    <div className="panel-item-label">Approval Status :</div>
                    <div className="panel-item-value"><StatusComp status={props.data.status}>{props.data.statusLabel}</StatusComp></div>
                </div>
                }
            
                 <div className="panel-item">
                    <div className="panel-item-label">Gift Type :</div>
                    <div className="panel-item-value">{props.data.giftType}</div>
                </div>

                <div className="panel-item">
                    <div className="panel-item-label">Given Date or Planned For :</div>
                    <div className="panel-item-value">{props.mode==="DETAIL"? props.data.giftDate:DateUtil.toStrDate(props.data.giftDate)}</div>
                </div>

                <div className="panel-item">
                    <div className="panel-item-label">Business Description :</div>
                    <div className="panel-item-value">{props.data.description}</div>
                </div>

                <div className="panel-item">
                    <div className="panel-item-label">Address :</div>
                    <div className="panel-item-value">{props.data.address}</div>
                </div>

                <div className="panel-item">
                    <div className="panel-item-label">Gift Value :</div>
                    <div className="panel-item-value">{props.data.giftValue}</div>
                </div>
                { !isJwCole &&
                    <div className="panel-item">
                        <div className="panel-item-label">Currency :</div>
                        <div className="panel-item-value">{props.data.currency}</div>
                    </div>
                }
            </div>
            
            <div className="panel-column">

                <div className="panel-item">
                    <div className="panel-item-label">Recipients :</div>
                    <div className="panel-item-value">{props.data.recipients}</div>
                </div>

                <div className="panel-item">
                    <div className="panel-item-label">Government Recipients :</div>
                    <div className="panel-item-value">{props.data.governmentRecipients}</div>
                </div>

                { !isJwCole &&
                    <div className="panel-item">
                        <div className="panel-item-label">Part of Contest or Raffle :</div>
                        <div className="panel-item-value">{props.data.raffleContest}</div>
                    </div>
                }

                {props.data.attachment && 
                <div className="panel-item">
                    <div className="panel-item-label">Attachment Document :</div>
                    <div className="panel-item-value">{props.data.attachment.fileName?props.data.attachment.fileName:props.data.attachment.name}</div>
                </div>
                }

                {props.data.employeeName &&
                    <div className="panel-item">
                        <div className="panel-item-label">Employee :</div>
                            <div className="panel-item-value">{props.data.employeeName}</div>
                    </div>
                }
                {props.data.submittedForLabel &&
                    <div className="panel-item">
                        <div className="panel-item-label">Submit On Behalf of :</div>
                        <div className="panel-item-value">{props.data.submittedForLabel}</div>
                    </div>
                }
                {props.data.submittedBy &&
                    <div className="panel-item">
                        <div className="panel-item-label">Submited By :</div>
                        <div className="panel-item-value">{props.data.submittedBy}</div>
                    </div>
                }

            </div>
            

        </div>
        
        <CommentComp data = {props.data.comments}/>

        
    </div>
    );

};

export default GiftDetail;